import { Button, Title, Text, Container } from "@mantine/core";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Container
      size="md"
      className="flex flex-col items-center justify-center text-center py-24"
    >
      <Title order={1} className="text-6xl font-bold mb-6 text-primary-5">
        404
      </Title>

      <Title order={2} className="text-2xl font-semibold mb-3">
        Page Not Found
      </Title>

      <Text size="lg" className="text-gray-500 mb-8 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </Text>

      <Button
        component={Link}
        to="/"
        size="md"
        radius="md"
        color="primary"
        className="px-8"
      >
        Go Home
      </Button>
    </Container>
  );
}
